import { motion } from "framer-motion";
import { TrendingDown, Zap, ShieldCheck } from "lucide-react";

const ITEMS = [
  {
    icon: TrendingDown,
    value: "−87%",
    label: "ручной работы у compliance-команд",
  },
  {
    icon: Zap,
    value: "12 000+",
    label: "автоматизированных размещений в месяц",
  },
  {
    icon: ShieldCheck,
    value: "0",
    label: "штрафов у клиентов с активной подпиской",
  },
];

export function SocialProofMetricsBand() {
  return (
    <section className="mt-20 w-full max-w-6xl px-4" aria-label="Результаты клиентов">
      <div className="grid gap-3 sm:grid-cols-3">
        {ITEMS.map((it, i) => {
          const Icon = it.icon;
          return (
            <motion.div
              key={it.label}
              initial={{ opacity: 0, y: 16 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.4, delay: i * 0.08 }}
              className="glass-card flex items-center gap-4 p-5"
            >
              <span className="grid h-12 w-12 shrink-0 place-items-center rounded-2xl bg-gradient-to-br from-primary/20 to-accent/20 ring-1 ring-primary/30">
                <Icon className="h-5 w-5 text-primary-light" />
              </span>
              <div className="min-w-0">
                <div className="bg-gradient-to-br from-primary to-accent bg-clip-text text-2xl font-extrabold text-transparent sm:text-3xl">
                  {it.value}
                </div>
                <div className="mt-0.5 text-xs text-muted-foreground">{it.label}</div>
              </div>
            </motion.div>
          );
        })}
      </div>
    </section>
  );
}
